module.exports = __webpack_public_path__ + "static/media/present-time.5ee75a69.jpg";